export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <span className="grid h-10 w-10 place-items-center rounded-2xl bg-[#FF6D47] shadow-[0_6px_16px_rgba(255,109,71,0.35)]">
      <svg viewBox="0 0 64 64" className="h-6 w-6" fill="white" aria-hidden="true">
        <circle cx="20.5" cy="19" r="4.6" />
        <circle cx="31" cy="15.5" r="4.8" />
        <circle cx="41.5" cy="19.5" r="4.6" />
        <path d="M31 50c-8.6-5.5-14.6-11.2-14.6-18 0-4.5 3.7-8.1 8.3-8.1 2.5 0 4.9 1.2 6.3 3.2 1.4-2 3.8-3.2 6.3-3.2 4.6 0 8.3 3.6 8.3 8.1 0 6.8-6 12.5-14.6 18z" />
      </svg>
    </span>
    <span className="leading-none">
      <span className={`font-display block text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#261C14]"}`}>
        PetLovers
      </span>
      <span className="block text-[10px] font-bold uppercase tracking-[0.28em] text-[#FF6D47]">Instituto</span>
    </span>
  </span>
);

export default Logo;
